module.exports = __webpack_public_path__ + "static/media/melodico_img.4718959c.jpg";